/** @format */

export const GET_BIO = "GET_BIO";
export const EDIT_BIO = "EDIT_BIO";
export const EDIT_BIO_IMAGE = "EDIT_BIO_IMAGE";
